// ajoute l'URL de la page actuelle dans le champ caché "input_31"
document.addEventListener("DOMContentLoaded", function() {
  var inputHideLPC = document.querySelector('input[name="input_31"]');
  if (inputHideLPC) {
    inputHideLPC.value = window.location.href;
  }
});